
$(document).ready(function () {
  if ($('.Slideshow-custom__Carousel').length) {
    $('.Slideshow-custom__Carousel').slick();
  }
  // CLOSE SELECT CURRENCY AND LANGUAGE WHEN CLOSE SIDEBAR MENU ON SP AND TABLET
  $('#sidebar-menu .Drawer__Close').click(function () {
    $('#sidebar-menu .SidebarMenu__localization button[aria-expanded="true"]').attr("aria-expanded", "false");
    $('#sidebar-menu .SidebarMenu__localization div[aria-hidden="false"]').attr("aria-hidden", "true");

  })

  $('').slick();



  function wordpressPostFeed() {
    var spScreen = window.matchMedia('(max-width: 999px)');
    var checkCounter = 0;
    const MAX_CHECKS = 20;

    var checkWPF = setInterval(function () {

      var $item = $('.swpf-container-ex .swpf-box');
      if ($item.length) {
        clearInterval(checkWPF);
        if (spScreen.matches) {

          $('.swpf-container-ex').not('.slick-initialized').slick({
            arrows: true,
            prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""></button>',
            nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""></button>',
            infinite: false,
            dots: true,
            slidesToShow: 1
          });
        } else {
          $('.swpf-container-ex').hasClass("slick-slider") && $('.swpf-container-ex').slick("unslick");
        }
      } else {
        checkCounter++;

        if (checkCounter >= MAX_CHECKS) {
          clearInterval(checkWPF);
        }
      }

    }, 100); // check every 100ms
  }

  wordpressPostFeed();

  $(window).resize(function () {
    wordpressPostFeed();
  });

  //   active menu sp
  function checkActiveMenuSp() {
    let url = window.location.pathname;
    $('.Search__navigation--link').each(function () {
      if (url == $(this).attr('href')) {
        $(this).addClass('is-active');
      } else {
        $(this).hasClass("is-active") && $(this).removeClass('is-active');;
      }
    })
  }

  checkActiveMenuSp();

  //   hide sp search menu when scroll

  //   $(window).resize(function() {
  //     if ($(window).width() < 1140){
  //       var announmentHeight = $('#shopify-section-announcement').height(),
  //           headerHeight = $('#section-header').height(),
  //           totalHeight = parseInt(announmentHeight + headerHeight),
  //           searchHeight = parseInt($("#Search").height() + 29);

  //       $("#Search").css({'position':'fixed','top': totalHeight});
  //       $('.shopify-section--slideshow').css('margin-top',searchHeight);

  //       $(window).scroll(function() {
  //         var scroll = $(window).scrollTop();

  //         if (scroll >= totalHeight) {
  //           $("#Search").addClass('scroll-hide');
  //         } else {
  //           $("#Search").removeClass('scroll-hide');
  //         }

  //         if (scroll > announmentHeight){
  //           $("#Search").css('top', headerHeight);
  //         } else {
  //           $("#Search").css('top', totalHeight);
  //         }
  //       });
  //     }
  //   })


  // $('.Header__Icon.Icon-Wrapper.Icon-Wrapper--clickable.hidden-desk').off('click').on('click', function (e) {
  //   //   $('.Header__Icon.Icon-Wrapper.Icon-Wrapper--clickable.hidden-desk').click(function(e){
  //   e.stopPropagation();

  //   if ($('.PageOverlay-2').hasClass('is-visible')) {
  //     $('.PageOverlay-2').toggleClass('is-visible');

  //     setTimeout(function () {
  //       $('#shopify-section-header').toggleClass('is-searchbar-open');
  //       $('.Search.Search-sp').toggleClass('is-show').css('top', $('#section-header').height());
  //       $('form.Search__Form').toggleClass('is-show');
  //     }, 500)
  //   } else {
  //     $('#shopify-section-header').toggleClass('is-searchbar-open');
  //     $('.Search.Search-sp').toggleClass('is-show').css('top', $('#section-header').height());
  //     $('form.Search__Form').toggleClass('is-show');

  //     setTimeout(function () {
  //       $('.PageOverlay-2').toggleClass('is-visible');
  //     }, 500)
  //   }
  // });

  $(document).on('click', function (e) {
    e.stopPropagation();

    if ($(e.target).closest('.Search.Search-sp').length === 0 && $('.Search.Search-sp').hasClass('is-show')) {
      $('.PageOverlay-2').removeClass('is-visible');

      setTimeout(function () {
        $('.Search.Search-sp').removeClass('is-show').css('top', 'unset');
        $('form.Search__Form').removeClass('is-show');
        $('#shopify-section-header').removeClass('is-searchbar-open zindexMobile');
      }, 500)
    }
  });

  //   setInterval(function () {
  //     let checkSearch = $('.boost-pfs-search-suggestion-wrapper.boost-pfs-search-suggestion-open');
  //     if (checkSearch.length){
  //       $('html').css("overflow-y", "hidden");
  //     }else{
  //       $('html').css("overflow-y", "auto");
  //     }
  //   }, 1000);


  function windowHeight() {
    $(window).on('resize', function () {
      if ($(this).width() <= 1007) {
        var windowHeight = $(window).height(),
          windowHeightInner = windowHeight - 100;

        $('.Product__Info .Product__Variants').css('height', windowHeight);
        $('.Product__Info .Product__Variants .Product__Variants--content').css('height', windowHeightInner);
      } else {
        $('.Product__Info .Product__Variants').css('height', 'auto');
        $('.Product__Info .Product__Variants .Product__Variants--content').css('height', 'auto');
      }
    })
  }

  windowHeight();

})
